var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17863_13946)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33343 0.390625L4.44644 3.50363C5.5098 2.96861 6.71945 2.66677 8.00009 2.66677C11.4075 2.66677 14.317 4.80529 15.3 7.79169L15.3686 8.00013L15.3 8.20856C14.8289 9.63973 13.9148 10.8759 12.7178 11.775L15.6096 14.6668L14.6668 15.6096L0.390625 1.33343L1.33343 0.390625ZM11.7635 10.8206C12.7674 10.1129 13.5389 9.13189 13.9604 8.00013C13.0977 5.68378 10.7669 4.0001 8.00009 4.0001C7.09152 4.0001 6.22952 4.18182 5.45093 4.50812L6.62776 5.68495C7.03341 5.46067 7.50241 5.33343 7.99957 5.33343C9.49554 5.33343 10.7622 6.49825 10.7622 8.0001C10.7622 8.51797 10.6092 8.99911 10.348 9.40518L11.7635 10.8206ZM9.3582 8.41539C9.40432 8.28402 9.42886 8.14435 9.42886 8.0001C9.42886 7.29282 8.81873 6.66677 7.99957 6.66677C7.87841 6.66677 7.76128 6.68075 7.64972 6.70691L9.3582 8.41539Z",
    fill: "#687386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28207 5.95526L2.87775 6.48533C2.52608 6.94635 2.24249 7.45569 2.03977 8.00006C2.90254 10.3164 5.23326 12.0001 8.00011 12.0001C8.27186 12.0001 8.53932 11.9838 8.80151 11.9524L9.46343 11.8729L9.62234 13.1967L8.96043 13.2762C8.64559 13.314 8.32507 13.3334 8.00011 13.3334C4.59265 13.3334 1.68315 11.1949 0.700188 8.20851L0.631583 8.00008L0.700189 7.79164C0.953131 7.02318 1.33401 6.31068 1.81762 5.67668L2.22195 5.14661L3.28207 5.95526Z",
    fill: "#687386"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17863_13946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.66c8e92faca28bef5679321edb6ec044.svg";
export { ForwardRef as ReactComponent };